import './styles/graphic.scss';
import Glide from '@glidejs/glide';

import textBalancer from 'text-balancer';

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;

  textBalancer.balanceText('.headline, .dek');

  new Glide('.glide', {
    autoplay: 4000,
    animationDuration: 2000,
    rewindDuration: 2000,
  }).mount();
}
